import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 4l-8 4l8 4l8 -4l-8 -4","key":"svg-0"}],["path",{"d":"M4 12l8 4l8 -4","key":"svg-1"}],["path",{"d":"M4 16l8 4l8 -4","key":"svg-2"}]]

/**
 * IconStack2
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc3RhY2stMiIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTIgNGwtOCA0bDggNGw4IC00bC04IC00IiAvPgogIDxwYXRoIGQ9Ik00IDEybDggNGw4IC00IiAvPgogIDxwYXRoIGQ9Ik00IDE2bDggNGw4IC00IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/stack-2
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconStack2 = createReactComponent('outline', 'stack-2', 'Stack2', __iconNode);

export default IconStack2;